import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Pipe({
    name: 'translator',
    pure: false
})
export class TranslatorPipe implements PipeTransform {

    constructor(private localizationService: LocalizationService) { }

    transform(
        item: any,
        fieldMap: { [language: string]: string }
    ): string {
        if (!item || !fieldMap) {
            return '';
        }

        const currentLang = this.localizationService.getCachedLanguage();
        if (!currentLang) return '';

        const fieldName = fieldMap[currentLang] || fieldMap['en'] || '';
        return item[fieldName] || '';
    }
}
